"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALIDATION_FIELD = exports.defaultCodesWithPopupMessage = exports.defaultCodesWithValidations = exports.EErrorStatus = void 0;
var EErrorStatus;
(function (EErrorStatus) {
    EErrorStatus[EErrorStatus["BadRequest"] = 400] = "BadRequest";
    EErrorStatus[EErrorStatus["Unauthorized"] = 401] = "Unauthorized";
    EErrorStatus[EErrorStatus["Forbidden"] = 403] = "Forbidden";
    EErrorStatus[EErrorStatus["NotFound"] = 404] = "NotFound";
    EErrorStatus[EErrorStatus["Conflict"] = 409] = "Conflict";
    EErrorStatus[EErrorStatus["PayloadTooLarge"] = 413] = "PayloadTooLarge";
    EErrorStatus[EErrorStatus["Validation"] = 422] = "Validation";
    EErrorStatus[EErrorStatus["FailedDependency"] = 424] = "FailedDependency";
    EErrorStatus[EErrorStatus["TooManyRequests"] = 429] = "TooManyRequests";
    EErrorStatus[EErrorStatus["RetryWith"] = 449] = "RetryWith";
    EErrorStatus[EErrorStatus["InternalServerError"] = 500] = "InternalServerError";
})(EErrorStatus = exports.EErrorStatus || (exports.EErrorStatus = {}));
exports.defaultCodesWithValidations = [EErrorStatus.Validation];
exports.defaultCodesWithPopupMessage = [
    EErrorStatus.BadRequest,
    EErrorStatus.Forbidden,
    EErrorStatus.Conflict,
    EErrorStatus.PayloadTooLarge,
    EErrorStatus.FailedDependency,
    EErrorStatus.TooManyRequests,
    EErrorStatus.RetryWith,
    EErrorStatus.InternalServerError
];
exports.DEFAULT_VALIDATION_FIELD = '_base';
//# sourceMappingURL=models.js.map